function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  d: "M21.15 20.04c-.82-.88-3.2-1.47-4.05-1.96-1.65-.7-1.27-1.84-1.27-1.9 0-.25.13-1.4.13-1.4s1.09-.96 1.6-2.41c.82-.51 1.13-.64 1.26-1.21 0 0 .25-2.3-.63-2.3 0 0-.38.06-.26-.44.13-.57.07-2.23 0-2.8-.06-.57.07-2.22-1.14-2.47-.83-.2-.96.06-1.34 0-.39-.07-.9-1.15-1.65-1.15l-1.6.25c-.76 0-.7.25-1.08.31s.06-.06-1.15.2c-1.2.25-1.64 1.84-1.7 2.4-.07.56-.13 2.22-.07 3.11.06.5-.32.5-.32.5-.7 0-.38 2.3-.38 2.3.13.56 0 .82 1.09 1.27.5 1.45 1.84 2.22 1.84 2.22s.06.96.06 1.65c-.12-.07.38 1.71-3.04 2.23-3.42.5-4.06 1.58-4.69 2.22-.43.43-.69 1.57-.76 2.21 5.02 0 21 .02 21 0s-.78-1.69-1.85-2.83z"
});

var SvgJunior = function SvgJunior(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgJunior, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/junior.083f0406.svg";
export { ForwardRef as ReactComponent };